import InputField from './inputField';

/**
 * @class FloatField
 */
export default class FloatField extends InputField {
    type = 'float';

    /**
     * `<div/>` container of field
     *
     * @property {jQuery} control
     */

    /**
     * `<input/>` element of field
     *
     * @property {jQuery} input
     */

    /**
     * Register key events on input field.
     *
     * @param {jQuery} input
     */
    registerEventsForInput(input) {
        input.on('keydown', (event) => {
            if (event.keyCode === 13 || event.keyCode === 9) { // enter || tab key
                this.startValue = Number(input.val());
                this.tryUpdateItem(this.currentItem);
            }
            event.stopPropagation();
        });

        input.on('keyup', ({ keyCode, shiftKey }) => {
            if (keyCode === 38) { // up-arrow key
                this.tryUpdateItem(this.currentItem, shiftKey ? 10 : 1);
            } else if (keyCode === 40) { // down-arrow key
                this.tryUpdateItem(this.currentItem, shiftKey ? -10 : -1);
            } else if (keyCode === 27) { // esc key
                input.val(this.startValue);
                this.tryUpdateItem(this.currentItem);
            }
        });

        input.on('focusin', () => (this.startValue = Number(input.val())));

        input.on('focusout', () => {
            if (this.startValue !== Number(input.val())) {
                this.setValue(this.startValue);
            }
        });
    }

    /**
     * Set input field value.
     *
     * @param {number} value
     */
    setValue(value) {
        this.input.val(Math.round(value * 100) / 100);
    }

    /**
     * Get input field value.
     *
     * @return {number}
     */
    getValue() {
        return parseFloat(
            this.input
                .val()
                .replace(',', '.'),
        );
    }
}
